import { motion } from "framer-motion";
import { SPRING } from "../theme";

interface ToggleProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  label?: string;
}

/** Spring pill toggle in the bronze "secondary" accent when on. */
export function Toggle({ checked, onChange, label }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      onClick={() => onChange(!checked)}
      className="relative h-6 w-12 shrink-0 rounded-full transition-colors"
      style={{ background: checked ? "var(--toggle-on, #765a24)" : "#c4c7c7" }}
    >
      <motion.span
        layout
        transition={SPRING}
        className="absolute top-0.5 h-5 w-5 rounded-full bg-white shadow-sm"
        style={{ left: checked ? "26px" : "2px" }}
      />
    </button>
  );
}
